import React, { useRef, useEffect, useContext } from 'react';
import styled, { keyframes } from 'styled-components';
import { HrBlockContainer } from '@components/styles/hr-styles';
import { DisplaySettingsContext } from '../store/display-settings';

const FadeIn = keyframes`
  0% {
    display: none;
    opacity: 0;
    top: 45%;
  }
  1% {
    display: block;
    opacity: 0;
    top: 45%;
  }
  100% {
    display: block;
    opacity: 1;
    top: 50%;
  }
`;

const ModalShadow = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 4;
  background-color: rgba(0, 0, 0, 0.6);
`;

const Constainer = styled(HrBlockContainer)`
  width: ${(props) => props.width || '94%'};
  max-width: 600px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 4;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  animation: ${FadeIn} 1s cubic-bezier(0.42, 0, 0, 1);
  animation-fill-mode: forwards !important;
  max-height: 90vh;
  margin: 16px;
  overflow-y: auto;
  & .div {
    position: relative;

    & .hr-Cross {
      position: absolute;
      top: 16px;
      right: 16px;
      z-index: 2;
      cursor: pointer;
      font-size: 24px;
    }
  }

  @media (max-width: 480px) {
    left: 46%;
  }
`;

/**
 * @deprecated Usar el componente de la carpeta components/v1/Modal.
 */

export const Modal = ({ setShowModal, handleClosedModal, children, width, noClose }) => {
  const closeModal = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          if (typeof handleClosedModal === 'function') {
            handleClosedModal();
          } else {
            setShowModal(false);
          }
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };
  const modal = useRef();
  closeModal(modal);
  const { darkMode } = useContext(DisplaySettingsContext);

  return (
    <ModalShadow>
      <Constainer ref={modal} backgroundColor={darkMode ? '#1A1D2B' : '#fff'} width={width}>
        <div className='div'>
          {!noClose && (
            <span
              style={{ color: darkMode ? '#9A9A9A' : '' }}
              className='hr-Cross'
              onClick={() => {
                setShowModal(false);
              }}
              onKeyPress={() => {
                setShowModal(false);
              }}
              role='button'
              tabIndex='0'
              aria-label='Close'
            />
          )}
          {children}
        </div>
      </Constainer>
    </ModalShadow>
  );
};
